import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { getRouteReportsSpendSummary } from 'shared/const/router';
import { getLastDrillCrumbLabel } from 'shared/lib/reports';
import { BackButton } from 'shared/ui/BackButton';

import {
    navigateSpendDrillBack,
    navigateSpendDrillToCrumb,
} from '../model/lib/spendDrillInNavigation';

import type { DrillCrumb } from 'shared/lib/reports/drillHistory';

interface SpendDrillInBackNavProps {
    trail?: DrillCrumb[];
    onBack: () => void;
    id?: string;
}

export const SpendDrillInBackNav = ({
    trail,
    onBack,
    id,
}: SpendDrillInBackNavProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const summaryLabel = t('spendSummary.reportTitle');
    const crumbs = useMemo(() => {
        const items = trail?.length
            ? trail
            : [
                  {
                      path: getRouteReportsSpendSummary(),
                      label: summaryLabel,
                  },
              ];

        return items
            .map((crumb) => ({
                label: crumb.label,
                onSelect: () => {
                    if (!trail?.length) {
                        navigateSpendDrillBack(navigate, trail);
                        return;
                    }

                    navigateSpendDrillToCrumb(navigate, crumb);
                },
            }))
            .reverse();
    }, [navigate, summaryLabel, trail]);

    const arrowLabel = getLastDrillCrumbLabel(trail, summaryLabel);

    return (
        <BackButton
            id={id}
            onBack={onBack}
            title={arrowLabel}
            crumbs={crumbs}
        />
    );
};
